import { render } from "./MessageList.vue?vue&type=template&id=7a794a29"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whitebox-portal/whitebox-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__